import { useEffect, useState } from 'react';
import { Container, Box, Grid, Typography, Card } from '@mui/material';
import Scrollbar from 'src/components/Scrollbar';
import useAuth from 'src/hooks/useAuth';
import { Table, TableHeader, TableBody, TableRow, TableCell } from 'src/@/components/ui/table';
import { resultTimes, validaLabelMenuDatas } from 'src/utils/functions';
import moment from 'moment';
import v2_actionRelatorioChamados from 'src/actions/v2/dashboard/relatorios/v2_actionRelatorioChamados';
import v2_actionRelatorioChamadosUsuarios from 'src/actions/v2/dashboard/relatorios/v2_actionRelatorioChamadosUsuarios';
import MenuDatas2 from 'src/components/MenuDatas2';

const Widget = ({ title, total }) => {
  return (
    <div className="flex flex-row gap-2 rounded bg-slate-100 p-3">
      <div>
        <Typography variant="h3">{total}</Typography>
        <p className="text-xs">{title}</p>
      </div>
    </div>
  );
};

export default function RelatorioChamados() {
  const { user } = useAuth();
  const [inicial, setInicial] = useState(new Date());
  const [final, setFinal] = useState(new Date());
  const [metricasChamados, setMetricasChamados] = useState(null);
  const [listaMetricasUsuarios, setListaMetricasUsuarios] = useState([]);
  const [periodo, setPeriodo] = useState('mes_atual');
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenuDatas = Boolean(anchorEl);

  useEffect(() => {
    handleBuscarDadosChamados(periodo);
  }, [inicial, final]);

  const handleBuscarDadosChamados = async (value) => {
    try {
      let inicio2 = moment(inicial).format("YYYY-MM-DD");
      let final2 = moment(final).format("YYYY-MM-DD");
      let querys = `?periodo=${value}&cliente_id=${user.clienteId}&inicio=${inicio2}&final=${final2}`;
      const res = await v2_actionRelatorioChamados(querys);
      const res2 = await v2_actionRelatorioChamadosUsuarios(querys);
      setMetricasChamados(res.data.data.total);
      setListaMetricasUsuarios(res2.data.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 2 }}>
        <div className="flex flex-row items-center gap-3 justify-between my-4">
          <div className="font-bold">Relatório de Chamados</div>
          <MenuDatas2
            onClose={() => setAnchorEl(null)}
            anchorEl={anchorEl}
            open={openMenuDatas}
            inicial={inicial}
            final={final}
            changeInicial={(newValue) => setInicial(newValue)}
            changeFinal={(newValue) => setFinal(newValue)}
            content={validaLabelMenuDatas(periodo, inicial, final)}
            onSelect={(value) => {
              setPeriodo(value);
              setAnchorEl(null);
              handleBuscarDadosChamados(value);
            }}
          />
        </div>

        <Box sx={{ backgroundColor: '#fff' }}>
          <Card sx={{ p: 3 }}>
            {metricasChamados && (
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4} md>
                  <Widget title="Abertos" total={metricasChamados.totalAberto} />
                </Grid>
                <Grid item xs={12} sm={4} md>
                  <Widget title="Pendentes" total={metricasChamados.totalPendente} />
                </Grid>
                <Grid item xs={12} sm={4} md>
                  <Widget title="Concluídos" total={metricasChamados.totalConcluido} />
                </Grid>
                <Grid item xs={12} sm={4} md>
                  <Widget title="Tempo Conclusão" total={0} />
                </Grid>
                <Grid item xs={12} sm={4} md>
                  <Widget title="Concluídos após Prazo" total={metricasChamados.atrasados} />
                </Grid>
                <Grid item xs={12} sm={4} md>
                  <Widget title="Cancelados" total={metricasChamados.totalCancelado} />
                </Grid>
                <Grid item xs={12} sm={4} md>
                  <Widget title="Recusados" total={metricasChamados.totalRecusado} />
                </Grid>
              </Grid>
            )}
          </Card>

          {listaMetricasUsuarios.length > 0 && (
            <Card sx={{ backgroundColor: '#fff', p: 1 }}>
              <Box>
                <Scrollbar>
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableCell>Usuário</TableCell>
                        <TableCell>Abertos</TableCell>
                        <TableCell>Pendentes</TableCell>
                        <TableCell>Concluídos</TableCell>
                        <TableCell>Tempo Conclusão</TableCell>
                        <TableCell>Concluídos após Prazo</TableCell>
                        <TableCell>Recusados</TableCell>
                        <TableCell>Cancelados</TableCell>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {listaMetricasUsuarios.map((row) => {
                        let tma = row.tma / row.count_tma;
                        return (
                          <TableRow key={row._id}>
                            <TableCell>{row.nomeUsuario}</TableCell>
                            <TableCell>{row.totalAberto || '-'}</TableCell>
                            <TableCell>{row.totalPendente || '-'}</TableCell>
                            <TableCell>{row.totalConcluido || '-'}</TableCell>
                            <TableCell>{tma ? resultTimes(tma) : '-'}</TableCell>
                            <TableCell>{row.totalAtrasados || '-'}</TableCell>
                            <TableCell>{row.totalRecusados || '-'}</TableCell>
                            <TableCell>{row.totalCancelado || '-'}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Scrollbar>
              </Box>
            </Card>
          )}
        </Box>
      </Box>
    </Container>
  );
}
